module.exports = __webpack_public_path__ + "img/teaching_5.53ec0f56.png";